// extracted by mini-css-extract-plugin
module.exports = {"heading":"Article_heading__jTSc2","container":"Article_container__M5qpB","paragraph":"Article_paragraph___Y5HT","list":"Article_list__F7_HS"};